module.exports = __webpack_public_path__ + "assets/img/reverse-sweep-5.7d600258.jpg";